// 처방 약 표시 이름 — POS 약은 product_name + strength (백엔드 11/05, Figma '리피토정 20mg'),
// 앱 처방 약은 기존 medication_name / name
export const medName = m => {
  if (!m) return '';
  if (m.product_name) return [m.product_name, m.strength].filter(Boolean).join(' ');
  return m.medication_name || m.name || m['약품명'] || '';
};
